<template>
    <form-row title="Purchase Price">
        <input-money
            v-model="price"
            name="purchase_price"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        price: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
